import { useCallback as i } from "react";
import { usePLMapboxStoreV2 as n } from "./index.es6.js";
const c = () => i(({ mapId: r, lng: a, lat: m, zoom: p }) => {
  var o, t;
  const e = (t = (o = n.getState().maps) == null ? void 0 : o[r]) == null ? void 0 : t.mapRef;
  e ? e.jumpTo({
    center: [a, m],
    zoom: p
  }) : console.warn("wait for map to be initialized");
}, []);
export {
  c as useZoomToCenter
};
//# sourceMappingURL=index.es180.js.map
